export default {
      id: "facial-recognition-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#facial-recognition",
      toString: function () {
        return this.url;
      }
    }